// client/plugins/SyncWrapperWithDocPlugin.ts
import { Plugin } from "prosemirror-state";
function SyncWrapperWithDocPlugin(wrapper) {
  return new Plugin({
    view(editorView) {
      updateWrapperAttributes(wrapper, editorView.state.doc.attrs);
      return {
        update(view) {
          updateWrapperAttributes(wrapper, view.state.doc.attrs);
        }
      };
    }
  });
}
function updateWrapperAttributes(wrapper, attrs) {
  Object.entries(attrs).forEach(([key, value]) => {
    if (value != null) {
      wrapper.setAttribute(key, value);
    } else {
      wrapper.removeAttribute(key);
    }
  });
}
export {
  SyncWrapperWithDocPlugin
};
